import styled, { css } from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { StatelessQuotationTotalVariants } from './StatelessQuotationTotal.constants';

export const $TotalLine = styled.div`
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $FinalTotalLine = styled.div<{
  $variant: StatelessQuotationTotalVariants;
}>`
  font-weight: ${fontWeight('bold')};
  color: ${({ theme }) => theme.colors.mainTextColor};

  ${({ $variant }) =>
    $variant === StatelessQuotationTotalVariants.SELFCARE
      ? css`
          background-color: ${({ theme }) => theme.colors.headerTitleColor};
          padding: ${spacing('lg')};

          display: flex;
          justify-content: end;
          margin-bottom: ${spacing('lg')};
          margin-top: ${spacing('lg')};
        `
      : undefined}
`;

export const $QuotationTotal = styled('div')`
  margin-bottom: ${spacing('lg')};
  text-align: right;
  margin-right: ${spacing('sm')};

  display: flex;
  flex-direction: column;
  justify-content: end;
  @media ${media.maxWidth.xs} {
    margin-right: unset;
  }
`;
